import {
    ADD_ROLE,
    ADD_ROLE_START,
    ADD_ROLE_ERROR,
    UPDATE_ROLE,
    UPDATE_ROLE_START,
    UPDATE_ROLE_ERROR,
    GET_ROLE,
    GET_ROLE_START,
    GET_ROLE_ERROR,
    GET_ROLE_LIST,
    GET_ROLE_LIST_START,
    GET_ROLE_LIST_ERROR,
    DELETE_ROLE,
    DELETE_ROLE_START,
    DELETE_ROLE_ERROR,
    GET_ACTION_LIST,
    GET_ACTION_LIST_START,
    GET_ACTION_LIST_ERROR,
    GET_ROLE_DTO_LIST,
    GET_ROLE_DTO_LIST_START,
    GET_ROLE_DTO_LIST_ERROR,
    ADD_ROLE_AND_RETURN_ROLE_DTO,
    ADD_ROLE_AND_RETURN_ROLE_DTO_START,
    ADD_ROLE_AND_RETURN_ROLE_DTO_ERROR,
    CLEAR_ERROR_ROLE,
    GET_ROLES_HASHMAP_LIST,
    GET_ROLES_HASHMAP_LIST_START,
    GET_ROLES_HASHMAP_LIST_ERROR,
  } from '../actions/types';
  
  const initialState = {
    roleList: [],
    roleDTOList: [],
    rolesHashMapList: [],
    role: {},
    loading: false,
    error: undefined,
    actionList: [],
    totalElements: '',
  };
  
  const clearError = (state) => {
    return {
      ...state,
      error: undefined,
    };
  };
  
  const addRoleStart = (state) => {
    return {
      ...state,
      loading: true,
      error: undefined,
    };
  };
  
  const addRole = (state, action) => {
    return {
      ...state,
      loading: false,
      roleDTOList: state.roleDTOList.concat(action.payload),
      error: undefined,
    };
  };
  
  const addRoleError = (state, action) => {
    return {
      ...state,
      error: action.payload,
      loading: false,
    };
  };
  
  const updateRoleStart = (state) => {
    return {
      ...state,
      error: undefined,
    };
  };
  
  const updateRole = (state, action) => {
    return {
      ...state,
      roleDTOList: state.roleDTOList.map((role) =>
        role.id === action.payload.id ? action.payload : role
      ),
      loading: false,
      error: undefined,
    };
  };
  
  const updateRoleError = (state, action) => {
    return {
      ...state,
      error: action.payload,
      loading: false,
    };
  };
  
  const findAllRolesStart = (state) => {
    return {
      ...state,
      loading: true,
      error: undefined,
    };
  };
  
  const findAllRoles = (state, action) => {
    return {
      ...state,
      loading: false,
      roleDTOList: action.payload[0],
      numberOfPages: action.payload[1],
      totalElements: action.payload[2],
      error: undefined,
    };
  };
  
  const findAllRolesError = (state, action) => {
    return {
      ...state,
      error: action.payload,
      loading: false,
    };
  };
  
  const findRoleByIdStart = (state) => {
    return {
      ...state,
      loading: true,
      error: undefined,
    };
  };
  
  const findRoleById = (state, action) => {
    return {
      ...state,
      loading: false,
      role: action.payload,
      error: undefined,
    };
  };
  
  const findRoleByIdError = (state, action) => {
    return {
      ...state,
      error: action.payload,
      loading: false,
    };
  };
  
  const deleteRoleStart = (state) => {
    return {
      ...state,
      loading: true,
      error: undefined,
    };
  };
  
  const deleteRole = (state, action) => {
    return {
      ...state,
      loading: false,
      roleDTOList: state.roleDTOList.filter((role) => role.id !== action.payload),
      error: undefined,
    };
  };
  
  const deleteRoleError = (state, action) => {
    return {
      ...state,
      error: action.payload,
      loading: false,
    };
  };
  
  const findAllActionsStart = (state) => {
    return {
      ...state,
      loading: true,
      error: undefined,
    };
  };
  
  const findAllActions = (state, action) => {
    return {
      ...state,
      loading: false,
      actionList: action.payload,
      error: undefined,
    };
  };
  
  const findAllActionsError = (state, action) => {
    return {
      ...state,
      error: action.payload,
      loading: false,
    };
  };
  
  const findAllRolesDTOStart = (state) => {
    return {
      ...state,
      loading: true,
      error: undefined,
    };
  };
  
  const findAllRolesDTO = (state, action) => {
    return {
      ...state,
      loading: false,
      roleDTOList: action.payload,
      error: undefined,
    };
  };
  
  const findAllRolesDTOError = (state, action) => {
    return {
      ...state,
      error: action.payload,
      loading: false,
    };
  };
  
  const addRoleAndReturnRoleDTOStart = (state) => {
    return {
      ...state,
      error: undefined,
    };
  };
  
  const addRoleAndReturnRoleDTO = (state, action) => {
    return {
      ...state,
      loading: false,
      roleDTOList: state.roleDTOList.concat(action.payload),
      error: undefined,
    };
  };
  
  const addRoleAndReturnRoleDTOError = (state, action) => {
    return {
      ...state,
      error: action.payload,
      loading: false,
    };
  };
  
  const findAllRolesHashMapListStart = (state) => {
    return {
      ...state,
      loading: true,
      error: undefined,
    };
  };
  
  const findAllRolesHashMapList = (state, action) => {
    return {
      ...state,
      loading: false,
      rolesHashMapList: action.payload,
      error: undefined,
    };
  };
  
  const findAllRolesHashMapListError = (state, action) => {
    return {
      ...state,
      error: action.payload,
      loading: false,
    };
  };
  
  export default function (state = initialState, action) {
    switch (action.type) {
      case ADD_ROLE:
        return addRole(state, action);
      case ADD_ROLE_START:
        return addRoleStart(state);
      case ADD_ROLE_ERROR:
        return addRoleError(state, action);
  
      case UPDATE_ROLE:
        return updateRole(state, action);
      case UPDATE_ROLE_START:
        return updateRoleStart(state);
      case UPDATE_ROLE_ERROR:
        return updateRoleError(state, action);
  
      case GET_ROLE:
        return findRoleById(state, action);
      case GET_ROLE_START:
        return findRoleByIdStart(state);
      case GET_ROLE_ERROR:
        return findRoleByIdError(state, action);
  
      case GET_ROLE_LIST:
        return findAllRoles(state, action);
      case GET_ROLE_LIST_START:
        return findAllRolesStart(state);
      case GET_ROLE_LIST_ERROR:
        return findAllRolesError(state, action);
  
      case DELETE_ROLE:
        return deleteRole(state, action);
      case DELETE_ROLE_START:
        return deleteRoleStart(state);
      case DELETE_ROLE_ERROR:
        return deleteRoleError(state, action);
  
      case GET_ROLE_DTO_LIST:
        return findAllRolesDTO(state, action);
      case GET_ROLE_DTO_LIST_START:
        return findAllRolesDTOStart(state);
      case GET_ROLE_DTO_LIST_ERROR:
        return findAllRolesDTOError(state, action);
  
      case GET_ACTION_LIST:
        return findAllActions(state, action);
      case GET_ACTION_LIST_START:
        return findAllActionsStart(state);
      case GET_ACTION_LIST_ERROR:
        return findAllActionsError(state, action);
  
      case ADD_ROLE_AND_RETURN_ROLE_DTO:
        return addRoleAndReturnRoleDTO(state, action);
      case ADD_ROLE_AND_RETURN_ROLE_DTO_START:
        return addRoleAndReturnRoleDTOStart(state);
      case ADD_ROLE_AND_RETURN_ROLE_DTO_ERROR:
        return addRoleAndReturnRoleDTOError(state, action);
      case CLEAR_ERROR_ROLE:
        return clearError(state);
  
      case GET_ROLES_HASHMAP_LIST:
        return findAllRolesHashMapList(state, action);
      case GET_ROLES_HASHMAP_LIST_START:
        return findAllRolesHashMapListStart(state);
      case GET_ROLES_HASHMAP_LIST_ERROR:
        return findAllRolesHashMapListError(state, action);
      default:
        return state;
    }
  }
  